import { Slider } from '@/components/ui/slider';
import { cn } from '@/lib/utils';

interface Props {
  label: string;
  value: number | null | undefined;
  onChange: (value: number | null) => void;
  disabled?: boolean;
}

export function MoodEnergySlider({ label, value, onChange, disabled = false }: Props) {
  const isSet = typeof value === 'number';
  const numericValue = isSet ? value : 5;

  return (
    <div className="flex flex-col gap-2.5">
      <div className="flex items-baseline justify-between">
        <span className="text-accent-ink text-[13px] font-medium">{label}</span>
        <span
          className={cn(
            'font-display flex items-baseline gap-1 italic',
            isSet ? 'text-accent-ink' : 'text-neutral-400',
          )}
        >
          <span className={cn('text-[18px] leading-none', !isSet && 'text-neutral-400')}>
            {isSet ? String(value) : '—'}
          </span>
          <span className="font-mono text-[10px] text-neutral-400 not-italic">/10</span>
        </span>
      </div>
      <Slider
        min={1}
        max={10}
        step={1}
        value={[numericValue]}
        onValueChange={(values) => {
          const v = values[0];
          if (v !== undefined) onChange(v);
        }}
        disabled={disabled}
        aria-label={label}
      />
      <div className="flex justify-between font-mono text-[10px] text-neutral-400">
        <span>low</span>
        <span aria-hidden>·</span>
        <span>5</span>
        <span aria-hidden>·</span>
        <span>high</span>
      </div>
    </div>
  );
}
